import { render } from "./HeroiconsSolidArrowNarrowDown.vue?vue&type=template&id=3088afd4"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidArrowNarrowDown.vue"]])

export default __exports__